import { Analysis, Granularity } from '../../../../dashboard-config/dashboard-config.model';
import {
  DashboardComparisonStructureAxisView,
  DashboardComparisonStructureView,
} from './dashboard-comparison-structure.definition';

export const COMPARISON_STRUCTURE_SHELL_ID = 'comparison-structure' as const;

export type DashboardComparisonStructureShell = 'districts';

export interface DashboardComparisonStructureShellProfile {
  id: typeof COMPARISON_STRUCTURE_SHELL_ID;
  analysisId: Analysis;
  granularityId: Granularity;
  geo: DashboardComparisonStructureAxisView;
  market: DashboardComparisonStructureAxisView;
  sideDefaults: DashboardComparisonStructureView['sideDefaults'];
  createHeading: (structureLabel: string) => () => string;
}

export const dashboardComparisonStructureShellProfiles: Record<DashboardComparisonStructureShell, DashboardComparisonStructureShellProfile> = {
  districts: {
    id: COMPARISON_STRUCTURE_SHELL_ID,
    analysisId: Analysis.Comparison,
    granularityId: Granularity.Districts,
    geo: {
      filterName: 'districts',
      valueKey: 'district_id',
      labelKey: 'district_name',
    },
    market: {
      filterName: 'sub_markets',
      valueKey: 'sub_market_id',
      labelKey: 'sub_market_name',
    },
    sideDefaults: {
      stateA: '1',
      stateB: '2',
    },
    createHeading: (structureLabel: string) => () =>
      `VERGLEICHSANALYSE DER ${structureLabel} ZWISCHEN ZWEI LANDKREISEN/-VERBÜNDEN`,
  },
};
